export default __webpack_public_path__ + "static/media/dress1.edc43819.jpeg";